export type TellOthersEligibility = {
  canGift: boolean;
  canInvite: boolean;
};

export function getTellOthersEligibility(
  eligibleToGift?: boolean | null,
  eligibleToInvite?: boolean | null
): TellOthersEligibility {
  return {
    canGift: eligibleToGift === true,
    canInvite: eligibleToInvite === true
  };
}

export function shouldShowTellOthersGenomicLifeCard(
  eligibility: TellOthersEligibility
): boolean {
  return eligibility.canGift || eligibility.canInvite;
}

export function shouldShowInviteFriendsDashboardBar(
  isMemberActive: boolean,
  eligibility: TellOthersEligibility
): boolean {
  return isMemberActive && shouldShowTellOthersGenomicLifeCard(eligibility);
}

export type TellOthersPrimaryAction = "modal" | "gift" | "invite";

export type TellOthersCopy = {
  message: string;
  primaryButtonText: string;
  primaryAction: TellOthersPrimaryAction;
};

export function getTellOthersDashboardBarHeadline(
  eligibility: TellOthersEligibility
): string {
  if (eligibility.canGift && !eligibility.canInvite) {
    return "Gift Genomic Life to someone you care about";
  }

  return "Invite the people you love to Genomic Life!";
}

export function getTellOthersCopy(
  isMemberActive: boolean,
  eligibility: TellOthersEligibility
): TellOthersCopy {
  const { canGift, canInvite } = eligibility;
  const both = canGift && canInvite;

  if (!isMemberActive) {
    if (canGift && !canInvite) {
      return {
        message:
          "With an active membership, you can buy gift plans. Simply reactivate your membership to share Genomic Life with your loved ones.",
        primaryButtonText: "Unlock",
        primaryAction: "modal"
      };
    }
    if (canInvite && !canGift) {
      return {
        message:
          "With an active membership, you can send invitations. Simply reactivate your membership to share Genomic Life with your loved ones.",
        primaryButtonText: "Unlock",
        primaryAction: "modal"
      };
    }
    return {
      message:
        "With an active membership, you can buy gift plans or send invitations. Simply reactivate your membership to share Genomic Life with your loved ones.",
      primaryButtonText: "Unlock",
      primaryAction: "modal"
    };
  }

  if (both) {
    return {
      message:
        "We are so glad you found us! If you've had a meaningful experience with Genomic Life, we would be honored if you invited others to join.",
      primaryButtonText: "Share Genomic Life",
      primaryAction: "modal"
    };
  }

  if (canGift) {
    return {
      message:
        "We are so glad you found us! If you'd like to share Genomic Life with someone you care about, you can purchase a gift membership for them.",
      primaryButtonText: "Gift a membership",
      primaryAction: "gift"
    };
  }

  return {
    message:
      "We are so glad you found us! If you've had a meaningful experience with Genomic Life, we would be honored if you invited others to join.",
    primaryButtonText: "Send an invite",
    primaryAction: "invite"
  };
}
